import { Component, computed, inject} from '@angular/core';
import { RouterModule ,Router} from '@angular/router';

import { UserService } from '../../services/user.service';

@Component({  
  selector: 'app-main-nav',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './main-nav.component.html',
  styleUrl: './main-nav.component.scss'
})
export class MainNavComponent {
  products = inject(UserService).userProducts;
  hasDashboard = computed(() => this.products().find(p => p.hasDashboard));
  constructor(private router: Router) {}

  onProductSelect(clientCode: string): void {
    if (clientCode) {
      this.router.navigate([`/${clientCode}`]);
    }
  }
}

